// Local multi-account store: remembers signed-in profiles so users can
// switch between them without retyping a password. Tokens are the same
// session tokens already stored for the active account.
const KEY = "riq_profiles";

export function getProfiles() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveProfile(user, token) {
  if (!user?.user_id || !token) return;
  const list = getProfiles().filter((p) => p.user_id !== user.user_id);
  list.unshift({
    user_id: user.user_id,
    email: user.email,
    name: user.name || "",
    picture: user.picture || null,
    token,
  });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 6)));
}

export function removeProfile(userId) {
  localStorage.setItem(KEY, JSON.stringify(getProfiles().filter((p) => p.user_id !== userId)));
}
